import { supabase } from '../../shared/supabase/supabaseClient';
import { useAuthStore } from '../../auth/store/useAuthStore';
import type { CustomerKpiSummary } from '../domain/customerTypes';

/**
 * ADR-017: RPC directo en todas las plataformas (sin SQLite).
 */
const EMPTY: CustomerKpiSummary = {
  debtTotal: 0,
  debtCount: 0,
  overdueCount: 0,
  blockedCount: 0,
};

export const getCustomerKpiSummary = async (branchId: string | null): Promise<CustomerKpiSummary> => {
  if (!branchId) return EMPTY;

  const { session } = useAuthStore.getState();
  if (!session) return EMPTY;

  const { data, error: rpcError } = await supabase.rpc('reports_org_fiado_kpi_summary');
  if (rpcError || !data) return EMPTY;

  const payload = data as {
    debt_total?: number;
    debt_count?: number;
    overdue_count?: number;
    blocked_count?: number;
  };
  return {
    debtTotal: Number(payload.debt_total ?? 0),
    debtCount: Number(payload.debt_count ?? 0),
    overdueCount: Number(payload.overdue_count ?? 0),
    blockedCount: Number(payload.blocked_count ?? 0),
  };
};
